import { Backdrop, Button, Paper, styled } from "@mui/material";
import colors from "../../../theme/themeConstants";
import { MouseEvent } from "react";
import { IGif } from "services/types";
import { TYPE_NUMBER_GIF, TYPE_NUMBER_IMAGE } from "../../../utils/constants";
import { useDeleteGifsMutation } from "../../../queries";
import { getGifIds } from "../../../utils/gif";

interface IProps {
  isOpen: boolean;
  gifs: IGif[];
  onClose: (removed?: boolean) => void;
}

const DeleteGifPopup = ({ isOpen, gifs, onClose }: IProps) => {
  const deleteGifsMutation = useDeleteGifsMutation();

  const getMessage = (): string => {
    const count = gifs.length;
    const currentTypes: number[] = [];
    const TYPE_NUMBER_GALLERY = 3;
    let text = "";

    gifs.forEach(({ type, gallery }) => {
      const value = gallery ? TYPE_NUMBER_GALLERY : type;

      if (currentTypes.indexOf(value) === -1) {
        currentTypes.push(value);
      }
    });

    if (currentTypes.length > 1) {
      text = `these ${count} items`;
    } else if (currentTypes[0] === TYPE_NUMBER_GIF) {
      text = count === 1 ? "this gif" : `these ${count} gifs`;
    } else if (currentTypes[0] === TYPE_NUMBER_IMAGE) {
      text = count === 1 ? "this image" : `these ${count} images`;
    } else if (currentTypes[0] === TYPE_NUMBER_GALLERY) {
      text = count === 1 ? "this gallery" : `these ${count} galleries`;
    }

    return `Are you sure want to delete ${text}?`;
  };

  const handleStopPropagation = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const handleRemove = async () => {
    const ids = await getGifIds(gifs);

    deleteGifsMutation.mutate(ids);

    onClose(true);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Backdrop open={isOpen} id={"popupOpen"}
      sx={{
        zIndex: 32
      }}
      onClick={handleClose}
    >
      <Paper onClick={handleStopPropagation} sx={{
        height: "14rem",
        margin: "0 1rem",
        borderRadius: "24px",
        padding: "2rem 1rem 0 1rem",

      }}>
        <p>{ getMessage() }</p>
        <Button onClick={handleRemove} fullWidth sx={{
          border: "none",
          color: "black",
          textDecoration: "underline",
          background: "transparent",
          marginTop: "1.5rem",
          ":hover": {
            border: "none",
            background: "none",
          }
        }}>
          Yes, delete
        </Button>

        <CancelDeleteButton
          onClick={handleClose}
          variant="outlined"
          fullWidth
        >
          No, cancel
        </CancelDeleteButton>
      </Paper >
    </Backdrop >
  );
};

export default DeleteGifPopup;

const CancelDeleteButton = styled(Button)({
  height: "52px",
  maxWidth: "83vw",
  margin: "1.5rem 0",
  borderRadius: "38px",
  background: colors.purpleGradient,
  border: `1px solid ${colors.purple}`,
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` }
});
